import { render, staticRenderFns } from "./ProjectStyleGuide.vue?vue&type=template&id=5f45d686&scoped=true&"
import script from "./ProjectStyleGuide.vue?vue&type=script&lang=js&"
export * from "./ProjectStyleGuide.vue?vue&type=script&lang=js&"
import style0 from "./ProjectStyleGuide.vue?vue&type=style&index=0&id=5f45d686&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f45d686",
  null
  
)

export default component.exports